import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d16508a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "h-100 d-flex align-items-center"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 2,
  class: "main w-100 d-flex justify-content-between align-items-center"
}
const _hoisted_6 = { class: "title fs-6 text-truncate" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs-75 default-name" }, "YELLoop 管理画面", -1))
const _hoisted_8 = { class: "fs-9 fw-bold text-truncate" }
const _hoisted_9 = { class: "user align-items-center d-flex" }
const _hoisted_10 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_11 = {
  key: 0,
  class: "user__name fs-75 fw-bold d-none d-lg-flex"
}
const _hoisted_12 = ["src"]

import { ref, watchEffect, computed, ComputedRef, PropType } from 'vue'

import ButtonScrollTop from '@/components/button-scroll-top/index.vue'
import Notification from '@/components/notification/index.vue'
import UserMenu from '@/components/header/user-menu-admin/index.vue'
import { useAuthenticated } from '@/use/authentication'
import { useLogoImage } from '@/use/headerLogo'
import { useStore } from 'vuex'
import { CommunityStateTypes } from '@/store/modules/community'
import { COMMUNITY_STORE } from '@/store/constants'
import { addCommunityHeaderParams, addUserIconParams, userType, usePath } from '@/use/usePath'
import { useRoute } from 'vue-router'
import ModalLogout from '../modal-logout/index.vue'
import ModalDetailNotification from '@/components/notification/components/ModalDetail.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  ShowMembership: {
    type: Function as PropType<() => void | undefined>,
  },
},
  setup(__props) {

const props = __props

const store = useStore()

const { path, id } = usePath()

const route = useRoute()

const { authenticated, required2FA } = useAuthenticated()

const { logo, corporationName, showUserAvatar } = useLogoImage()

const profile = computed<ComputedRef<Pick<CommunityStateTypes, 'me'>>>(() => store.getters[COMMUNITY_STORE.GETTERS.GET_ME]?.profile)
const profileCommunity = computed<ComputedRef<Pick<CommunityStateTypes, 'me'>>>(() => store.getters[COMMUNITY_STORE.GETTERS.COMMUNITY_INFO])

const imageUrl = ref('')
const imageLogo = ref('')



watchEffect(() => {
  if (typeof profile.value?.image_url !== 'string' && profile.value?.image_url) {
    imageUrl.value = URL.createObjectURL(profile.value?.image_url)
    return
  } else {
    imageUrl.value = profile.value?.image_url
  }
})

watchEffect(() => {
  if (typeof logo.value !== 'string' && logo) {
    imageLogo.value = URL.createObjectURL(logo.value)
    return
  } else {
    imageLogo.value = logo.value
  }
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", {
      class: _normalizeClass(['d-flex bg-white pl-3 sticky-top shadow', _unref(profileCommunity)?.image_url ? '' : 'align-items-center'])
    }, [
      (_unref(route).params?.id)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: `/${_unref(path)}/communities/${_unref(id)}/dashboard`,
            class: _normalizeClass(['h-100 d-flex', _unref(profileCommunity)?.image_url ? 'background-image img-header' : 'align-items-center'])
          }, {
            default: _withCtx(() => [
              (_unref(profileCommunity)?.image_url)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _unref(addCommunityHeaderParams)(_unref(logo)),
                    alt: "logo",
                    id: "logo"
                  }, null, 8, _hoisted_1))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: require('@/assets/images/YELLoop_logo_slogan.svg'),
                    alt: "logo",
                    id: "logo2"
                  }, null, 8, _hoisted_2))
            ]),
            _: 1
          }, 8, ["to", "class"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("img", {
              src: require('@/assets/images/YELLoop_logo_slogan.svg'),
              alt: "logo",
              id: "logo2"
            }, null, 8, _hoisted_4)
          ])),
      (_unref(authenticated) && !_unref(required2FA))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(corporationName)), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              (_unref(showUserAvatar))
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    (_unref(profile))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(`${_unref(profile)?.family_name} ${_unref(profile)?.given_name}`), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("img", {
                      class: "user__avatar rounded-circle d-none d-lg-flex",
                      src: imageUrl.value ? _unref(addUserIconParams)(imageUrl.value, _unref(userType)()) : require('@/assets/images/user-empty.svg')
                    }, null, 8, _hoisted_12)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(Notification, { "from-admin-site": "" }),
              _createVNode(UserMenu, { ShowMembership: __props.ShowMembership }, null, 8, ["ShowMembership"])
            ])
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(ButtonScrollTop),
    _createVNode(ModalLogout),
    _createVNode(ModalDetailNotification)
  ], 64))
}
}

})